import { AsyncActionState } from '@telstra-connect/standard-actions/async-action';
import { IAppointmentResponse } from './order-details';

export interface ISubStageComment {
    reason: string;
    type: string;
    date?: string;
}

export interface ISubStage {
    name: string;
    status: string;
    date?: string;
    content?: string;
    subContent?: string[];
    comments?: ISubStageComment[];
}

export interface IOrderInfoPrimaryStage {
    name: string;
    status: string;
    substages: ISubStage[];
    subHeader?: string;
}

export interface IOrderInfoSummary {
    location: string;
    product: string;
    subLocation: string;
    siteName: string;
    uuid: string;
    type: string;
}

export interface IOrderInfoLocationInt {
    aEnd?: string,
    zEnd?: string
}

export interface IOrderInfoProgress {
    uuid: string;
    name: string;
    nickName: string;
    type: string;
    fnn?: string;
    status?: string;
    location: string | IOrderInfoLocationInt;
    estimatedDate: string;
    requiredDate: string;
    closedDate: string;
    primaryStageVariables?: IPrimaryStageVariables;
    primaryStage: IOrderInfoPrimaryStage[];
    hardwareDelivery: IHardwareDelivery[];
    siteName?: string;
    billingDate?: string;
    cancelPointOfNoReturnReached?: boolean;
    pointOfNoReturnReached?: boolean;
    suspensionReason?: string;
    telstraFieldAppointmentRequiredFlag?: boolean;
    orderLineItemReference: string;
    appointmentData?: IAppointmentResponse;
    category?: string;
}

export interface IPrimaryStageVariables {
    solutionOrderType?: string;
}

export interface IHardwareDeliverySiteContact {
    name: string;
    email: string;
}

export interface IHardwareDelivery {
    name: string;
    location: string;
    estimatedDate: string;
    consignmentNumber: string,
    quantity: number;
    trackingUrl: string;
    siteContact: IHardwareDeliverySiteContact;
}

export interface IOrderInfoSubstageMainContent {
    default: string;
    completed?: string | IOrderInfoSubstageMainContentSubContent;
    'in progress'?: string;
}

interface IOrderInfoSubstageMainContentSubContent {
    default?: string,
    modify?: string
}

export interface IOrderInfoSubstageContent {
    name: string;
    content?: string;
    subContent?: string[];
    mainContent?: IOrderInfoSubstageMainContent;
    primaryStage?: string;
}

export interface IOrderInfoSubstageCommentsContent {
    reason: string;
    comment: string;
}

export interface IOrderInfoTemp {
    productName: string;
    productType: string;
    siteAddress: string;
}

export interface ITestResultAttachments {
    sourceSystem?: string,
    attachmentPathOrId?: string,
    attachmentName?: string
}
export interface ITestResultInfo {
    customerLetterType?: string,
    customerLetterStatus?: string,
    testResultAttachments?: ITestResultAttachments[]
}
export interface ICustomerAcceptance {
    customerAcceptanceStatus?: string;
    testResultInfo?: ITestResultInfo | string;
    billingStartDate?: string;
    orderEnqCaseId?: string;
    acceptCallStatus?: AsyncActionState;
}

export interface IOrderInfoResponse {
    status: string;
    amendStatus: string;
    orderClosedDate: string;
    requiredDate: string;
    estimatedDate: string;
    ncp?: string;
    selectedProduct: string;
    selectedSummaryItem: string;
    selectedViewBy?: string;
    summary: IOrderInfoSummary[];
    calculatedSummary?: object;
    progress: IOrderInfoProgress[];
    substageContent?: IOrderInfoSubstageContent[];
    emptySubstageContent?: IOrderInfoSubstageContent[];
    substageCommentsContent: IOrderInfoSubstageCommentsContent[];
    originalData?: IOrderInfoResponse;
    yourReference?: string;
    projectManager?: string;
    customerName?: string;
    primaryContact?: string;
    contractSignedDate?: string;
    referenceOrders: string[];
    fulfilmentVersion?: number;
    suspendResumeContent?: object;
    relatedRequestNumber?: string;
    billingStartDate?: string;
    customerAcceptance?: ICustomerAcceptance;
    submittedToSDDate?: string;
    rootProductType?: string;
    solutionOrderType?: string;
    flowType?: string;
}

export interface ILoadOrderInfoRequest {
    data: IOrderInfoResponse;
    status: AsyncActionState;
    temp?: IOrderInfoTemp;
    error?: string;
}

export const defaultInitialState: IOrderInfoResponse = {
    status: '',
    amendStatus: '',
    orderClosedDate: '',
    requiredDate: '',
    estimatedDate: '',
    ncp: '',
    selectedProduct: null,
    selectedSummaryItem: null,
    selectedViewBy: '',
    summary: [],
    progress: [],
    substageContent: [],
    emptySubstageContent: [],
    substageCommentsContent: [],
    projectManager: '',
    yourReference: '',
    customerName: '',
    primaryContact: '',
    contractSignedDate: '',
    referenceOrders: [],
    fulfilmentVersion: null,
    suspendResumeContent: null,
    relatedRequestNumber: '',
    rootProductType: '',
    solutionOrderType: '',
    flowType: ''
}
export enum OrderFlowType {
    legacy = 'legacy',
    strategic = 'strategic',
    international = 'international'
}
